<template>
  <van-dialog
    v-model="show"
    :title="title"
    show-cancel-button
    @close="close"
    @confirm="confirm"
  >
    <div>
      <van-uploader v-model="fileList" :max-count="2"/>
      <van-field
        v-model="message"
        autosize
        maxlength="50"
        placeholder="针对上述图片或视频的文字标注和描述"
        rows="2"
        show-word-limit
        type="textarea"
      />
    </div>
  </van-dialog>
</template>

<script>
export default {
  data() {
    return {
      target: {},
      show: false,
      message: "",
      title: "",
      //上传图片的列表
      fileList: [],
    };
  },
  //监听target的数据变化
  watch: {
    target: {
      handler(val) {
        /* console.log(
           val,
           "-------------------------------------------------------"
         );*/
        if (val.status) {
          if (val.content.pic.length > 0 && typeof val.content.pic[0] === 'string') {
            const arr = val.content.pic
            const newArr = arr.map(url => ({url}));
            this.fileList = val.content.pic ? [...newArr] : [];
          } else {
            this.fileList = val.content.pic ? [...val.content.pic] : [];
          }
          this.message = val.content.desc;
          console.log(this.fileList)

        }
      },
    },
  },

  methods: {
    //显示base64格式的图片
    base64ToImgSrc(file) {
      if (typeof file === 'string') {
        console.log(file)
        return file
      } else {
        return file.content;
      }
    },
    //点击确认后，引用父组件的方法将三个参数传进去
    confirm() {
      this.$emit("configPic", this.target.id, this.fileList, this.message);
    },
    //点击取消后赋值为空
    close() {
      this.fileList = [];
      this.message = "";
      this.target = {};
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/material_upload/material_uploadPic.vue